import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MixPanelTrackingService } from 'src/app/services/mixpanel-tracking.services';

@Component({
  selector: 'app-SenseVideo',
  templateUrl: './SenseVideo.component.html',
  styleUrls: ['./SenseVideo.component.scss']
})
export class SenseVideoComponent implements OnInit, OnDestroy {
  menuName: string;
  src: string;
  private subscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private mixPanelTrackingService: MixPanelTrackingService
  ) { }

  ngOnInit() {
    const userinfo = JSON.parse(localStorage.getItem("userinfo"));

    // Get menuName from route params immediately
    this.menuName = this.route.snapshot.queryParams['section'] || '';
    if (!userinfo.customersProd[0]?.senseGroup.menuSections.find(x => x.name.toLowerCase() == this.menuName.toLowerCase()))
    {
      this.router.navigateByUrl('unauthorized');
    }
    this.subscription = this.route.queryParams.pipe(
      switchMap(params => {
        this.menuName = params['section'] || '';
        this.mixPanelTrackingService.onTrackSenseVideoNavigate(this.menuName, 'direct_link');
        let queryUrl = environment.senseVideo + "?menu=" + this.menuName;
        let httpOptions: Object = {
          headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
          responseType: 'text'
        };
        return this.http.get<any>(queryUrl, httpOptions);
      })
    ).subscribe(
      response => {
        let res = JSON.parse(response);
        // Reset src to null first to force video element to be destroyed and recreated
        this.src = null;
        // Set the new src after a brief delay to ensure DOM update
        setTimeout(() => {
          this.src = res.url;
        }, 10);
      },
      error => {
        console.log(error);
      }
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
